import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import routes from 'routes';
import { filterRoutesByUserRole } from 'plugins/router/guards';
import layoutNames from 'utils/enums/layout-names.enum';

import styles from 'assets/jss/material-dashboard-pro-react/layouts/authStyle';

import register from 'assets/img/register.jpeg';
import login from 'assets/img/login.jpeg';
import lock from 'assets/img/lock.jpeg';
import error from 'assets/img/clint-mckoy.jpg';
import changePassword from 'assets/img/login.jpeg';

const useStyles = makeStyles(styles);

export default function Pages() {
	// ref for the wrapper div
	const wrapper = React.createRef();
	// styles
	const classes = useStyles();
	React.useEffect(() => {
		document.body.style.overflow = 'unset';
		// Specify how to clean up after this effect:
		return function cleanup() { };
	});
	const getRoutes = (routes) => {
		return routes.filter(filterRoutesByUserRole).map((prop, key) => {
			if (prop.collapse) {
				return getRoutes(prop.views);
			}
			if (prop.layout === `/${layoutNames.auth}`) {
				return (
					<Route
						path={prop.layout + prop.path}
						component={prop.component}
						key={key}
					/>
				);
			} else {
				return null;
			}
		});
	};
	const getBgImage = () => {
		if (window.location.pathname.indexOf(`/${layoutNames.auth}/register`) !== -1) {
			return register;
		} else if (window.location.pathname.indexOf(`/${layoutNames.auth}/change-password`) !== -1) {
			return changePassword;
		} else if (window.location.pathname.indexOf(`/${layoutNames.auth}/login`) !== -1) {
			return login;
		} else if (
			window.location.pathname.indexOf(`/${layoutNames.auth}/lock`) !== -1
		) {
			return lock;
		} else if (window.location.pathname.indexOf(`/${layoutNames.auth}/error-page`) !== -1) {
			return error;
		}
	};

	// eslint-disable-next-line no-unused-vars
	const getActiveRoute = (routes) => {
		let activeRoute = 'Sevis';
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse) {
				let collapseActiveRoute = getActiveRoute(routes[i].views);
				if (collapseActiveRoute !== activeRoute) {
					return collapseActiveRoute;
				}
			} else {
				if (
					window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
				) {
					return routes[i].name;
				}
			}
		}
		return activeRoute;
	};
	return (
		<div>
			<div className={classes.wrapper} ref={wrapper}>
				<div
					className={classes.fullPage}
					style={{ backgroundImage: `url(${getBgImage()})` }}
				>
					<Switch>
						{getRoutes(routes)}
						<Redirect from={`/${layoutNames.auth}`} to={`/${layoutNames.auth}/login`} />
					</Switch>
				</div>
			</div>
		</div>
	);
}
